export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readTime: string;
  thumbnailUrl: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    slug: "keji-shuma",
    name: "科技数码",
    description: "探索前沿科技趋势，了解最新数码产品资讯，掌握数字时代的每一个精彩瞬间。免费91网页为您精选科技数码领域的优质内容。",
    icon: "ri-smartphone-line",
    articleCount: 20,
  },
  {
    id: "cat-2",
    slug: "shenghuo-baike",
    name: "生活百科",
    description: "汇集实用生活技巧与百科知识，从家居妙招到出行指南，让您的生活更加便捷高效。免费91网页陪伴您的品质生活。",
    icon: "ri-home-heart-line",
    articleCount: 18,
  },
  {
    id: "cat-3",
    slug: "yule-xiuxian",
    name: "娱乐休闲",
    description: "关注影视音乐、游戏动漫、旅行美食等休闲领域，为您带来轻松愉快的阅读体验。免费91网页是您休闲时光的最佳伙伴。",
    icon: "ri-movie-line",
    articleCount: 22,
  },
  {
    id: "cat-4",
    slug: "jiaoyu-xuexi",
    name: "教育学习",
    description: "提供在线学习资源、考试攻略、技能提升指南，助力您的终身学习之旅。免费91网页让知识触手可及。",
    icon: "ri-book-open-line",
    articleCount: 15,
  },
  {
    id: "cat-5",
    slug: "jiankang-yangsheng",
    name: "健康养生",
    description: "分享科学健康知识、养生保健方法、运动健身指导，守护您和家人的身心健康。免费91网页关心您的每一天。",
    icon: "ri-heart-pulse-line",
    articleCount: 17,
  },
];

export const articles: Article[] = [
  // 科技数码 - 4 articles
  {
    id: "art-1",
    slug: "2025-ai-fazhan-qushi",
    title: "2025年人工智能发展趋势：从大模型到AI应用的全面爆发",
    excerpt: "人工智能技术正在以惊人的速度发展，大语言模型的突破让AI应用进入了一个全新的阶段。本文将深入解析2025年AI领域的最新趋势和未来展望。",
    content: `<p>人工智能在2025年迎来了前所未有的发展高潮。从年初开始，各大科技公司纷纷推出了新一代的大语言模型，这些模型不仅在参数规模上有了显著提升，更重要的是在实际应用场景中的表现更加出色。</p>
<p>首先值得关注的是多模态AI的崛起。新一代的AI系统不再局限于文本处理，而是能够同时理解和生成文本、图像、音频甚至视频内容。这种多模态能力让AI应用的范围大大扩展，从智能客服到创意设计，从医疗诊断到自动驾驶，AI正在渗透到各个行业。</p>
<p>其次，AI Agent（智能体）的概念在2025年真正落地。不同于传统的聊天机器人，AI Agent能够自主规划任务、调用工具、执行复杂的多步骤操作。例如，一个AI Agent可以帮用户规划旅行行程、预订酒店、安排交通，全程无需人工干预。</p>
<p>在企业级应用中，AI正在重塑工作方式。智能文档处理、自动化代码生成、AI驱动的数据分析等工具已经成为企业提高效率的标配。据调查显示，超过70%的企业已经在至少一个业务环节中部署了AI解决方案。</p>
<p>然而，AI的快速发展也带来了新的挑战。数据隐私、算法偏见、就业结构变化等问题引发了广泛讨论。各国政府正在加快制定AI监管政策，力求在创新与安全之间找到平衡。</p>
<p>展望未来，AI将更加深入地融入我们的日常生活。从个性化教育到精准医疗，从智慧城市到可持续能源管理，AI的潜力还远未被完全挖掘。正如一位行业专家所说：\"我们正站在AI革命的起点，最令人兴奋的变化还在前方。\"</p>`,
    categorySlug: "keji-shuma",
    author: "科技观察员",
    publishDate: "2025-08-01",
    readTime: "8分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20digital%20brain%20and%20neural%20network%20patterns%20on%20a%20clean%20minimal%20background%2C%20soft%20warm%20lighting%2C%20modern%20tech%20aesthetic%2C%20professional%20editorial%20style&width=800&height=450&seq=art-1-thumb&orientation=landscape",
  },
  {
    id: "art-2",
    slug: "shouji-xingpian-xuangou-zhinan",
    title: "2025年智能手机选购指南：主流旗舰芯片性能横评",
    excerpt: "面对市面上琳琅满目的智能手机，如何选择一款适合自己的设备？本文从芯片性能、影像系统、续航能力等多个维度，为您提供全面的选购参考。",
    content: `<p>2025年的智能手机市场竞争依然激烈，各大品牌纷纷推出了搭载最新芯片的旗舰机型。对于普通消费者来说，面对繁多的型号和参数，如何做出明智的选购决策成了一个不小的挑战。</p>
<p>在芯片方面，2025年主流的旗舰平台包括高通的骁龙8 Gen 4、苹果的A18 Pro以及联发科的天玑9400。从性能测试来看，这三款芯片在CPU单核性能上差距不大，但在多核性能和GPU表现上各有所长。对于游戏玩家来说，骁龙8 Gen 4的光线追踪能力值得关注；而对于视频创作者，A18 Pro的媒体引擎优势明显。</p>
<p>影像系统方面，2025年的旗舰机型普遍采用了大底主摄+超广角+长焦的三摄组合。计算摄影技术的进步让手机摄影的成片率大幅提升，特别是在夜景和人像模式下。值得注意的是，AI影像处理已经成为标配，能够自动识别场景并优化拍摄参数。</p>
<p>续航能力是另一个关键因素。2025年，硅碳负极电池技术逐渐普及，让手机在保持轻薄机身的同时拥有更大的电池容量。快充技术也在不断进步，百瓦级快充已经成为旗舰机的标配。</p>
<p>在选购建议上，如果您追求综合体验，iPhone 16系列依然是稳妥的选择；如果您是安卓阵营的拥趸，搭载骁龙8 Gen 4的各家旗舰都有各自的特色功能；如果您注重性价比，搭载天玑9400的中高端机型是不错的替代方案。</p>`,
    categorySlug: "keji-shuma",
    author: "数码评测师",
    publishDate: "2025-07-28",
    readTime: "10分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displayed%20on%20a%20clean%20white%20minimal%20background%20with%20soft%20shadows%2C%20elegant%20product%20photography%20style%2C%20warm%20neutral%20tones%2C%20professional%20lighting&width=800&height=450&seq=art-2-thumb&orientation=landscape",
  },
  {
    id: "art-3",
    slug: "web3-qukuailian-xinjishu",
    title: "Web3与区块链技术的最新进展：去中心化应用的未来",
    excerpt: "Web3概念持续升温，区块链技术在金融、社交、游戏等领域的应用不断深化。了解这些前沿技术如何改变互联网的运作方式。",
    content: `<p>Web3作为下一代互联网的愿景，在2025年继续吸引着全球开发者和投资者的目光。与传统的Web2相比，Web3强调去中心化、用户数据主权和价值的公平分配。</p>
<p>在技术层面，以太坊2.0的全面升级为去中心化应用提供了更高效的基础设施。Layer 2扩展方案如Arbitrum和Optimism大幅降低了交易成本，让普通用户也能负担得起链上操作。跨链互操作协议的发展让不同区块链网络之间的资产和数据流动变得更加顺畅。</p>
<p>去中心化金融（DeFi）依然是Web3最活跃的领域。2025年，DeFi协议的总锁仓量创下新高，新型金融产品如链上衍生品、结构化产品和收益聚合器不断涌现。更重要的是，越来越多的传统金融机构开始尝试将DeFi协议整合到其服务体系中。</p>
<p>非同质化代币（NFT）的应用场景也在不断拓展。除了数字艺术品和收藏品，NFT技术在数字身份、票务系统、供应链追溯等实用场景中找到了新的价值。品牌方利用NFT建立会员体系和忠诚度计划的做法越来越普遍。</p>`,
    categorySlug: "keji-shuma",
    author: "区块链研究员",
    publishDate: "2025-07-20",
    readTime: "7分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Abstract%20digital%20blockchain%20network%20visualization%20with%20interconnected%20nodes%20on%20a%20clean%20minimal%20background%2C%20warm%20amber%20and%20gold%20accents%2C%20modern%20tech%20concept%20art&width=800&height=450&seq=art-3-thumb&orientation=landscape",
  },
  {
    id: "art-4",
    slug: "zhineng-jiaju-shenghuo",
    title: "智能家居生态全解析：打造真正的智慧生活空间",
    excerpt: "从智能音箱到全屋智能，智能家居已经走进了千家万户。本文全面解析当前主流智能家居生态，帮助您构建属于自己的智慧生活空间。",
    content: `<p>智能家居的概念已经提出了很多年，但直到最近几年，随着技术的成熟和生态的完善，它才真正开始走进普通家庭。2025年的智能家居市场呈现出百花齐放的局面。</p>
<p>目前市场上主流的智能家居生态包括苹果的HomeKit、小米的米家、华为的鸿蒙智联以及亚马逊的Alexa生态。各生态在设备兼容性、自动化能力和用户体验上各有特色。对于已经深度使用某一品牌手机的用户来说，选择对应的智能家居生态通常能获得最无缝的体验。</p>
<p>在设备品类上，智能照明、智能安防和智能温控是渗透率最高的三大品类。智能门锁已经成为了新装家庭的标配，而智能窗帘、智能晾衣架等品类也在快速增长。值得注意的是，Matter协议的统一让不同品牌的设备能够在同一网络中共存和协作，这是智能家居普及的重要推动力。</p>
<p>从体验层面来看，自动化场景是智能家居的核心价值。例如，\"离家模式\"可以一键关闭所有灯光和电器、启动安防系统；\"回家模式\"则自动开启灯光、调节空调温度、播放背景音乐。这些场景化的自动操作大大提升了生活的便利性和舒适度。</p>`,
    categorySlug: "keji-shuma",
    author: "智能生活家",
    publishDate: "2025-07-15",
    readTime: "9分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Modern%20smart%20home%20interior%20with%20connected%20devices%20and%20warm%20ambient%20lighting%2C%20minimalist%20living%20room%20design%2C%20clean%20aesthetic%2C%20soft%20neutral%20tones&width=800&height=450&seq=art-4-thumb&orientation=landscape",
  },
  // 生活百科 - 4 articles
  {
    id: "art-5",
    slug: "jiaju-shouna-miaozhao",
    title: "家居收纳妙招大公开：小空间也能有大作为",
    excerpt: "房间空间有限却杂物繁多？本文分享10个实用的家居收纳技巧，让您的居住空间焕然一新，从此告别杂乱无章的生活环境。",
    content: `<p>无论是租房还是自有住房，收纳始终是困扰很多人的问题。特别是对于居住在小户型中的朋友来说，如何在有限的空间内实现高效的收纳，是一门值得研究的学问。</p>
<p>首先，垂直空间的利用是收纳的关键。很多人只关注地面面积，却忽视了墙面和垂直空间。安装壁挂式置物架、门后挂钩、磁性刀架等，可以大大增加可利用的收纳面积。床底空间也不要浪费，使用带滚轮的收纳盒可以轻松存取换季衣物。</p>
<p>其次，分类收纳的原则不可忽视。将物品按照使用频率和类别进行分类，常用物品放在触手可及的位置，不常用的物品则可以收纳在较高的柜子或较深的储物空间中。使用统一的收纳盒并贴上标签，能让您快速找到需要的物品。</p>
<p>多功能家具也是小户型的救星。带储物功能的床、可折叠的餐桌、沙发床等，都能在需要时提供额外的功能而不占用过多空间。在选择家具时，优先考虑那些\"一物多用\"的设计。</p>
<p>最后，定期断舍离是保持空间整洁的根本。每隔一段时间审视自己的物品，将不再需要的物品捐赠或处理掉。记住，收纳的目标不是把更多东西塞进空间，而是让每件物品都有自己的位置。</p>`,
    categorySlug: "shenghuo-baike",
    author: "生活整理师",
    publishDate: "2025-08-02",
    readTime: "6分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Organized%20minimalist%20closet%20interior%20with%20neatly%20folded%20clothes%20and%20storage%20boxes%2C%20warm%20natural%20light%2C%20clean%20Scandinavian%20design%20aesthetic%2C%20cozy%20home%20organization&width=800&height=450&seq=art-5-thumb&orientation=landscape",
  },
  {
    id: "art-6",
    slug: "lvyou-chuxing-shengqian",
    title: "旅行出行省钱攻略：如何在预算内享受高品质旅程",
    excerpt: "旅游不一定要花大价钱。本文为您总结了从机票预订到住宿选择的全方位省钱技巧，让您在有限的预算内也能享受美好的旅行体验。",
    content: `<p>旅行是很多人生活中不可或缺的一部分，但旅行费用往往会成为限制出行的因素。其实，只要掌握一些省钱技巧，完全可以在不牺牲体验的前提下，大幅降低旅行成本。</p>
<p>在机票方面，灵活选择出行日期是省钱的第一步。通常周二和周三的机票价格最低，而节假日前后则最贵。提前45-60天预订通常能获得较好的价格，但也不要过早预订。使用多个比价平台交叉验证价格，并开启价格提醒功能。</p>
<p>住宿选择上，除了传统酒店，民宿和青旅提供了更具性价比的选项。对于家庭出游或结伴旅行，整套公寓的租金往往比订多间酒店房间更划算，而且还附带厨房可以自己做简单的餐食。如果行程灵活，临近出发日期预订往往能捡到\"最后一刻\"的优惠。</p>
<p>在目的地消费方面，提前做好功课非常重要。了解当地的公共交通系统可以省下大量打车费用；寻找当地人常去的餐馆而非游客聚集区，不仅价格实惠，口味也更地道。很多城市还提供旅游通票，包含多个景点的门票和公共交通，性价比很高。</p>
<p>最后，旅行保险虽然是一项额外支出，但在关键时刻可能帮您省下大笔费用。特别是国际旅行，医疗和行李延误的保障非常有必要。</p>`,
    categorySlug: "shenghuo-baike",
    author: "旅行达人",
    publishDate: "2025-07-30",
    readTime: "7分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Travel%20planning%20concept%20with%20world%20map%20and%20camera%20on%20wooden%20desk%2C%20warm%20sunlight%2C%20adventure%20vibe%2C%20clean%20lifestyle%20photography%20style&width=800&height=450&seq=art-6-thumb&orientation=landscape",
  },
  {
    id: "art-7",
    slug: "meishi-pengren-jiqiao",
    title: "厨房新手必学：10道零失败的入门家常菜",
    excerpt: "不会做饭？不用担心！我们为您挑选了10道简单易学的家常菜，即使是厨房新手也能轻松上手，从此告别外卖生活。",
    content: `<p>对于很多厨房新手来说，做饭似乎是一件令人生畏的事情。但事实上，只要掌握了基本的方法和几道基础菜品，任何人都能在厨房中找到乐趣和成就感。</p>
<p>第一道推荐的是番茄炒蛋，这可以说是中国家常菜的入门必修课。关键在于先炒鸡蛋至七八分熟盛出，再炒番茄出汁，最后将鸡蛋回锅混合。简单的调料——盐和少许糖——就能带出番茄的自然酸甜和鸡蛋的嫩滑。</p>
<p>第二道是蒜蓉西兰花，这是一道兼具营养和颜值的快手菜。将西兰花焯水后沥干，热油爆香蒜末，快速翻炒即可。焯水时在水中加少许盐和油，能让西兰花保持翠绿的色泽。</p>
<p>接下来的菜品包括青椒肉丝、麻婆豆腐、可乐鸡翅、清炒时蔬、酸辣土豆丝、红烧排骨、清蒸鱼和蛋炒饭。每一道都是经过时间检验的经典家常菜，食材易得，做法清晰，成功率极高。</p>
<p>烹饪其实是一门熟能生巧的技艺。从最简单的菜品开始，每次成功后记录心得，很快您就会发现自己的厨艺在不知不觉中突飞猛进。最重要的是享受烹饪的过程，因为用心做出的饭菜总是最美味的。</p>`,
    categorySlug: "shenghuo-baike",
    author: "美食博主",
    publishDate: "2025-07-25",
    readTime: "11分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Beautiful%20home-cooked%20Chinese%20dishes%20on%20a%20wooden%20dining%20table%2C%20warm%20lighting%2C%20comfort%20food%20photography%2C%20clean%20rustic%20kitchen%20aesthetic&width=800&height=450&seq=art-7-thumb&orientation=landscape",
  },
  {
    id: "art-8",
    slug: "zhiwu-yanghu-rumen",
    title: "植物养护入门指南：让家中绿植四季常青",
    excerpt: "想在家里养绿植却总是养不活？本文从光照、浇水、土壤等基础要素入手，教您如何科学养护室内植物，让绿色常伴左右。",
    content: `<p>室内植物不仅能美化家居环境，还能净化空气、舒缓心情。但对于很多\"植物杀手\"来说，养好一盆绿植似乎总是一种奢望。其实，只要掌握了基础的养护知识，大多数常见室内植物都很好养活。</p>
<p>光照是植物生长的第一要素。不同的植物对光照的需求差异很大：多肉植物和仙人掌需要充足的直射阳光，而绿萝、龟背竹等则适合明亮的散射光环境。在选择植物之前，先观察家中不同位置的光照条件，然后选择适合的品种。</p>
<p>浇水是新手最容易出错的地方。大多数室内植物死于浇水过多而非过少。判断是否需要浇水的方法是：将手指插入土壤约2-3厘米，如果感觉干燥则需要浇水。浇则浇透，直到水从排水孔流出，然后倒掉托盘中的积水。</p>
<p>土壤和肥料也是养护的关键。室内植物应使用专门的营养土，保证良好的透气性和排水性。在生长季节（春夏季），每月施一次稀释的液体肥料即可满足植物的营养需求。秋冬季节植物进入休眠期，应减少施肥。</p>`,
    categorySlug: "shenghuo-baike",
    author: "园艺爱好者",
    publishDate: "2025-07-18",
    readTime: "6分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Beautiful%20indoor%20plants%20arrangement%20in%20a%20bright%20minimalist%20living%20room%2C%20natural%20sunlight%20streaming%20through%20window%2C%20cozy%20green%20interior%20design&width=800&height=450&seq=art-8-thumb&orientation=landscape",
  },
  // 娱乐休闲 - 4 articles
  {
    id: "art-9",
    slug: "2025-remen-dianying-tuijian",
    title: "2025年最值得期待的10部电影：从科幻大片到文艺佳作",
    excerpt: "电影爱好者注意了！本文盘点了2025年下半年最令人期待的10部电影，涵盖科幻、动作、动画、文艺等多种类型，总有一部适合您。",
    content: `<p>2025年的电影市场精彩纷呈，从好莱坞商业大片到独立制作的文艺佳作，每一部都值得走进电影院去感受大银幕的魅力。以下是今年下半年最值得期待的十部电影。</p>
<p>科幻类方面，《星际探索者：新纪元》无疑是今年的重头戏。作为系列第三部，这部影片将带领观众探索更深远的宇宙空间，视觉效果令人叹为观止。另一部值得关注的科幻片是《数字灵魂》，讲述了一个关于AI意识和人类情感的深刻故事。</p>
<p>动作冒险类中，《极限特工：重生》延续了系列的高强度动作场面，而《古城秘境》则将探险题材与中国传统文化元素巧妙结合，创造出了独特的视听体验。</p>
<p>动画电影方面，国产动画的进步有目共睹。《山海经之苍龙觉醒》以中国传统神话为背景，画面精美程度不输好莱坞顶级制作。日本动画大师新海诚的新作也将在年末上映，粉丝们可以好好期待。</p>
<p>文艺片爱好者也不要错过《时光书店》和《南方的雨季》，这两部作品在各大电影节上获得了极高的评价，是今年不容错过的艺术佳作。</p>`,
    categorySlug: "yule-xiuxian",
    author: "影评人老张",
    publishDate: "2025-08-03",
    readTime: "8分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20posters%20displayed%20artistically%20on%20a%20dark%20wall%2C%20warm%20ambient%20lighting%2C%20elegant%20entertainment%20photography%2C%20classic%20cinema%20aesthetic&width=800&height=450&seq=art-9-thumb&orientation=landscape",
  },
  {
    id: "art-10",
    slug: "duyouxi-jingdian-tuijian",
    title: "2025年独立游戏精选：这些被低估的佳作值得一试",
    excerpt: "除了3A大作，独立游戏领域也涌现出许多创意十足的优秀作品。我们为您精选了2025年最值得体验的10款独立游戏。",
    content: `<p>在3A大作动辄上百GB容量的今天，独立游戏以其独特的创意、精美的艺术风格和紧凑的游戏体验，赢得了越来越多玩家的青睐。2025年的独立游戏市场格外活跃，涌现出不少令人惊喜的作品。</p>
<p>《星之回声》是一款结合了音乐节奏和冒险解谜的创新游戏。玩家需要通过演奏不同的旋律来解开谜题、与角色互动，游戏的原创音乐由知名独立音乐人担纲制作，每一首曲子都值得反复聆听。</p>
<p>《微光之城》则是一款以光影为核心机制的2D平台跳跃游戏。玩家操控一个能操控光影的小精灵，在美丽的手绘风格世界中穿梭。游戏的难度曲线设计非常精妙，既不会让新手感到挫败，也能给硬核玩家带来挑战。</p>
<p>叙事类游戏方面，《她的最后一封信》用一个下午茶的时间讲述了一个温暖治愈的故事。游戏通过阅读信件、拼凑记忆碎片的方式，缓缓展开一段跨越半个世纪的爱情故事。</p>`,
    categorySlug: "yule-xiuxian",
    author: "游戏编辑小王",
    publishDate: "2025-07-29",
    readTime: "7分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Artistic%20indie%20game%20scene%20with%20beautiful%20hand-drawn%20illustration%20style%2C%20warm%20color%20palette%2C%20creative%20game%20design%20concept%2C%20cozy%20atmospheric%20lighting&width=800&height=450&seq=art-10-thumb&orientation=landscape",
  },
  {
    id: "art-11",
    slug: "yinyue-liuxing-yuce",
    title: "2025下半年音乐流行趋势预测：哪些曲风将引领潮流",
    excerpt: "音乐潮流不断演变，2025年下半年哪些音乐风格将成为主流？从独立民谣到电子融合，让我们一探音乐世界的未来走向。",
    content: `<p>音乐潮流的演变从未停止，每个时代都有其标志性的声音。2025年的音乐场景呈现出多元化融合的趋势，传统的流派界限正在被打破。</p>
<p>独立民谣在2025年继续保持着强劲的上升势头。越来越多的年轻音乐人选择回归质朴的创作方式，用一把吉他和真实的声音讲述生活故事。与商业化制作不同，这些独立民谣作品充满了真诚和个人色彩，在流媒体平台上获得了令人瞩目的播放量。</p>
<p>电子音乐与民族元素的融合也是2025年的一大亮点。制作人们将中国传统的民族乐器采样与现代电子节拍相结合，创造出了既有文化底蕴又不失现代感的新声音。这种\"国风电音\"正在获得国际音乐界的关注。</p>
<p>嘻哈音乐继续主导着年轻人的播放列表，但2025年的嘻哈更加注重旋律性和叙事深度。新一代的说唱歌手不再局限于传统的街头叙事，而是将视角拓展到了更广阔的社会议题和个人成长。</p>`,
    categorySlug: "yule-xiuxian",
    author: "音乐评论员",
    publishDate: "2025-07-22",
    readTime: "6分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Vinyl%20records%20and%20headphones%20on%20a%20warm%20lit%20desk%2C%20music%20listening%20room%20atmosphere%2C%20cozy%20retro%20aesthetic%2C%20soft%20ambient%20lighting&width=800&height=450&seq=art-11-thumb&orientation=landscape",
  },
  {
    id: "art-12",
    slug: "dongman-xinfan-tuijian",
    title: "2025年秋季新番动漫前瞻：这些作品不容错过",
    excerpt: "动漫迷们注意了！2025年秋季新番即将来袭，我们整理了最值得关注的10部新番动漫，提前了解精彩内容，做好追番准备。",
    content: `<p>每年秋季都是动漫新番集中放送的黄金季节，2025年的秋季番同样精彩纷呈。从备受期待的续作到全新的原创动画，总有一部能打动你的心。</p>
<p>续作方面，《命运之环》第三季无疑是最大的看点。前两季以其精良的制作和扣人心弦的剧情赢得了广泛好评，第三季将揭开更多关于世界观的谜团。另一部人气续作《剑与魔法学院》也将在秋季回归，新学期的冒险故事即将展开。</p>
<p>新作方面，改编自热门轻小说的《异世界料理人》备受期待。故事讲述了一位天才厨师穿越到剑与魔法的异世界，用美食征服异世界居民的温馨故事。动画制作由业界顶尖团队负责，从预告片来看，美食场景的作画质量令人垂涎。</p>
<p>原创动画《星空下的约定》也值得关注。这部作品由新锐导演执导，以一个海边小镇为舞台，讲述了几位少年少女关于梦想与成长的故事。唯美的画风和治愈的氛围让人联想到吉卜力的经典作品。</p>`,
    categorySlug: "yule-xiuxian",
    author: "动漫情报站",
    publishDate: "2025-07-16",
    readTime: "7分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20beautiful%20scenery%20and%20characters%2C%20warm%20sunset%20color%20palette%2C%20Japanese%20animation%20aesthetic%2C%20dreamy%20atmospheric%20scene&width=800&height=450&seq=art-12-thumb&orientation=landscape",
  },
  // 教育学习 - 4 articles
  {
    id: "art-13",
    slug: "zaixian-xuexi-pingtai",
    title: "2025年最佳在线学习平台对比：找到最适合你的学习方式",
    excerpt: "在线教育蓬勃发展，各类学习平台层出不穷。本文全面对比主流在线学习平台的特点和优势，帮助您找到最适合自己的学习路径。",
    content: `<p>在线学习已经成为现代人提升自我的重要途径。从专业技能到兴趣爱好，从语言学习到编程开发，各种在线学习平台为学习者提供了前所未有的便利。但面对众多的选择，如何找到最适合自己的平台呢？</p>
<p>Coursera和edX作为国际知名的MOOC平台，提供了大量来自世界顶级大学的课程。如果你希望获得系统性的学术知识，并能接受全英文授课，这两个平台是很好的选择。它们还提供付费证书项目，对职业发展有一定帮助。</p>
<p>对于中文学习者来说，国内的在线学习平台更加贴近实际需求。一些平台主打职业技能培训，课程内容涵盖编程、设计、营销等热门领域，课程结构紧凑，注重实操。另一些则侧重兴趣学习，从摄影、绘画到音乐、写作，品类丰富。</p>
<p>语言学习方面，Duolingo以其游戏化的学习体验吸引了大量用户，而iTalki则通过连接母语教师提供一对一的语言练习机会。选择哪个取决于您的学习风格——喜欢自主学习还是需要有人指导。</p>`,
    categorySlug: "jiaoyu-xuexi",
    author: "教育观察者",
    publishDate: "2025-08-01",
    readTime: "9分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Modern%20online%20learning%20setup%20with%20laptop%20and%20notebooks%20on%20a%20clean%20wooden%20desk%2C%20warm%20natural%20light%2C%20cozy%20study%20environment%2C%20minimal%20workspace&width=800&height=450&seq=art-13-thumb&orientation=landscape",
  },
  {
    id: "art-14",
    slug: "biancheng-rumen-zhinan",
    title: "零基础编程入门指南：2025年最值得学习的第一门编程语言",
    excerpt: "想要学习编程却不知从何开始？本文为零基础学习者分析了各主流编程语言的特点，推荐最适合新手的入门语言和高效学习路径。",
    content: `<p>在数字化时代，编程能力正变得越来越重要。无论你是想转行进入IT行业，还是仅仅想掌握一项新技能，选择正确的入门语言都能让学习之旅事半功倍。</p>
<p>对于零基础学习者来说，Python通常是最推荐的入门语言。它的语法简洁直观，接近自然语言，初学者可以很快上手并看到成果。Python的应用领域也非常广泛，从数据分析、人工智能到Web开发、自动化脚本，学会Python后可以探索多个方向。</p>
<p>如果你对前端开发感兴趣，JavaScript是一个很好的选择。作为Web开发的核心语言，JavaScript可以让你创建交互式的网页效果。配合HTML和CSS，你能在很短的时间内做出可见的成果，这种即时反馈对保持学习动力很有帮助。</p>
<p>学习路径方面，建议从在线互动教程开始，比如Codecademy或freeCodeCamp。这些平台提供了循序渐进的课程和即时练习环境。在掌握了基础语法后，做一个自己感兴趣的小项目是巩固知识的最好方式。</p>
<p>重要的是不要贪多求快。每天保持30-60分钟的持续学习，坚持三个月左右就能建立起扎实的编程基础。记住，编程是一项实践性很强的技能，\"看懂了\"和\"会写了\"之间有着本质的区别。</p>`,
    categorySlug: "jiaoyu-xuexi",
    author: "编程导师",
    publishDate: "2025-07-27",
    readTime: "10分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Clean%20coding%20workspace%20with%20laptop%20showing%20code%20editor%2C%20warm%20minimal%20desk%20setup%2C%20modern%20developer%20environment%2C%20soft%20ambient%20lighting&width=800&height=450&seq=art-14-thumb&orientation=landscape",
  },
  {
    id: "art-15",
    slug: "yingyu-xuexi-gaoxiao",
    title: "高效英语学习方法：从入门到流利的完整路径",
    excerpt: "学了多年英语还是不敢开口？本文分享经过验证的高效英语学习方法，从听说读写四个维度全面提升您的英语能力。",
    content: `<p>英语作为国际通用语言，其重要性不言而喻。然而很多学习者花了大量时间却收效甚微，问题的根源往往在于方法不当。以下是经过实践检验的高效学习方法。</p>
<p>听力方面，\"可理解性输入\"是核心原则。选择你能听懂70%-80%内容的材料，这样既能学习新内容，又不至于因为太难而放弃。推荐从慢速英语新闻开始，逐步过渡到播客和电影原声。关键是每天坚持至少20分钟。</p>
<p>口语能力的提升需要大胆开口。语言交换App可以帮助你找到母语者进行交流练习。不要害怕犯错，记住：流利度比准确度更重要，先能做到沟通，再追求完美。自己录音然后回听，也是发现问题的好方法。</p>
<p>阅读方面，分级读物是入门阶段的最佳选择。随着水平提升，可以过渡到英文新闻网站和原版书籍。遇到生词不要立即查字典，先尝试通过上下文猜测含义，这能锻炼阅读理解能力。</p>`,
    categorySlug: "jiaoyu-xuexi",
    author: "英语教练Lisa",
    publishDate: "2025-07-20",
    readTime: "8分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=English%20learning%20setup%20with%20textbooks%20and%20notebook%20on%20a%20bright%20desk%2C%20warm%20sunlight%2C%20motivational%20study%20environment%2C%20clean%20educational%20photography&width=800&height=450&seq=art-15-thumb&orientation=landscape",
  },
  {
    id: "art-16",
    slug: "kaoyan-beikao-gonglve",
    title: "考研备考全攻略：从规划到上岸的每一步",
    excerpt: "考研是一场持久战，科学的备考规划至关重要。本文为考研学子提供从院校选择到复试准备的完整备考指南。",
    content: `<p>考研是很多大学生的重要人生选择，但备考过程往往充满挑战。一个合理的备考规划可以让这个过程更加高效和有方向。</p>
<p>首先是院校和专业的选择。建议在大三下学期之前就确定目标，综合考虑院校排名、专业实力、地理位置、往年录取分数线等因素。不要盲目追求名校，选择与自己实力匹配且专业方向感兴趣的目标更为重要。</p>
<p>备考时间规划方面，一般来说，大三下学期开始基础复习，暑假进行强化训练，大四上学期进行冲刺和模拟。每天保持8-10小时的有效学习时间，但每周也要安排半天的休息时间，避免长期高强度学习导致的倦怠。</p>
<p>公共课方面，政治可以从暑假开始系统复习，数学和英语则需要更早开始打基础。专业课的复习要紧紧围绕目标院校的参考书目和历年真题。多做真题、总结错题是提高成绩的有效方法。</p>`,
    categorySlug: "jiaoyu-xuexi",
    author: "考研过来人",
    publishDate: "2025-07-12",
    readTime: "11分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Student%20studying%20at%20a%20library%20desk%20with%20books%20and%20notes%2C%20warm%20focused%20lighting%2C%20academic%20atmosphere%2C%20clean%20educational%20environment&width=800&height=450&seq=art-16-thumb&orientation=landscape",
  },
  // 健康养生 - 4 articles
  {
    id: "art-17",
    slug: "kexue-jianfei-fangfa",
    title: "科学减肥方法全解析：告别无效节食，健康瘦下来",
    excerpt: "减肥是很多人关注的话题，但错误的方法不仅效果不佳，还可能伤害身体。本文介绍经过科学研究验证的健康减肥方法。",
    content: `<p>减肥是现代社会最热门的话题之一，各种减肥方法层出不穷。但在尝试任何减肥方案之前，了解科学原理至关重要。真正有效的减肥方法都遵循一个基本原则：创造合理的热量缺口。</p>
<p>饮食方面，关键在于\"吃什么\"而非\"吃多少\"。增加蛋白质摄入有助于维持肌肉量并提升饱腹感；选择全谷物代替精制碳水可以稳定血糖；多吃蔬菜不仅能提供必要的微量元素，其高纤维含量也有助于肠道健康。建议采用\"餐盘法\"：餐盘的一半放蔬菜，四分之一放蛋白质，四分之一放主食。</p>
<p>运动方面，有氧运动和力量训练的结合效果最佳。每周3-4次30-45分钟的中等强度有氧运动（如快走、慢跑、游泳），配合2-3次力量训练，可以有效提升基础代谢率。不必一开始就追求高强度，循序渐进才能长期坚持。</p>
<p>睡眠和压力管理同样影响着减肥效果。研究表明，长期睡眠不足和慢性压力会扰乱饥饿激素的平衡，导致食欲增加。保证每晚7-8小时的优质睡眠，学会通过冥想或深呼吸缓解压力。</p>`,
    categorySlug: "jiankang-yangsheng",
    author: "营养师小陈",
    publishDate: "2025-08-02",
    readTime: "9分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Healthy%20food%20bowl%20with%20fresh%20vegetables%20and%20ingredients%20on%20a%20light%20wooden%20table%2C%20natural%20sunlight%2C%20clean%20wellness%20lifestyle%20photography&width=800&height=450&seq=art-17-thumb&orientation=landscape",
  },
  {
    id: "art-18",
    slug: "shuimian-zhiliang-tisheng",
    title: "提升睡眠质量的10个科学方法：告别失眠困扰",
    excerpt: "失眠和睡眠质量差是现代人的常见问题。本文分享10个经过科学验证的提升睡眠质量的方法，帮助您每晚都能享受深度好眠。",
    content: `<p>良好的睡眠是身心健康的基础，但据调查显示，超过三分之一的成年人存在不同程度的睡眠问题。幸运的是，大多数睡眠问题都可以通过调整生活习惯来改善。</p>
<p>首先，建立规律的作息时间是改善睡眠最重要的一步。每天在同一时间入睡和起床（包括周末），可以帮助身体建立稳定的生物钟。即使某天睡得不好，第二天也不要赖床太晚，否则会打乱后续的睡眠节律。</p>
<p>睡前的\"数字排毒\"同样关键。手机、电脑和电视屏幕发出的蓝光会抑制褪黑素的分泌，影响入睡。建议睡前一小时放下所有电子设备，可以改为阅读纸质书、听轻音乐或进行简单的伸展运动。</p>
<p>卧室环境的优化也不可忽视。理想的睡眠环境应该是黑暗、安静且凉爽的。遮光窗帘、白噪音机和将室温控制在18-22°C都是有效的环境优化手段。选择适合自己的枕头和床垫也能显著提升睡眠舒适度。</p>
<p>另外，咖啡因的摄入时间需要注意。咖啡因在体内的半衰期约为5-6小时，建议下午两点之后就不要再摄入含咖啡因的饮品。晚餐也不宜过饱或过晚，睡前2-3小时完成晚餐是比较理想的安排。</p>`,
    categorySlug: "jiankang-yangsheng",
    author: "睡眠健康顾问",
    publishDate: "2025-07-28",
    readTime: "8分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Peaceful%20bedroom%20interior%20with%20soft%20bedding%20and%20warm%20ambient%20lighting%2C%20cozy%20sleep%20environment%2C%20minimal%20design%2C%20relaxing%20atmosphere&width=800&height=450&seq=art-18-thumb&orientation=landscape",
  },
  {
    id: "art-19",
    slug: "siji-yangsheng-zhinan",
    title: "四季养生指南：顺应自然的健康生活方式",
    excerpt: "中医讲究顺应四时变化来调养身体。本文结合传统养生智慧和现代医学知识，为您提供春夏秋冬四季的健康养生建议。",
    content: `<p>中国传统养生文化强调\"天人合一\"，认为人体健康与自然界的变化密切相关。随着季节更替调整生活方式，是保持健康的重要法则。</p>
<p>春季是万物复苏的季节，养生重在\"生发\"。此时应早睡早起，适当增加户外活动，让身体沐浴在温暖的春光中。饮食上宜清淡，多吃新鲜蔬菜和芽苗类食物，如春笋、韭菜、菠菜等。春季也是养肝的好时节，保持心情舒畅对肝脏健康尤为重要。</p>
<p>夏季阳气最盛，养生重在\"养心\"。避免在烈日下长时间活动，注意补充水分。饮食上可以适当增加苦味食物如苦瓜、莲子心等来清热解暑。虽然天热，但不宜过度贪凉，空调温度不宜过低，冰镇饮料也要适量。</p>
<p>秋季气候干燥，养生重在\"润肺\"。多吃梨、百合、银耳等滋润食物，注意补充水分。\"秋冻\"要适度，早晚温差大时应及时添衣。秋季也是调整作息的好时机，逐渐从夏天的晚睡早起过渡到早睡早起。</p>`,
    categorySlug: "jiankang-yangsheng",
    author: "中医养生师",
    publishDate: "2025-07-22",
    readTime: "7分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Four%20seasons%20nature%20collage%20with%20spring%20flowers%20and%20autumn%20leaves%2C%20warm%20harmonious%20color%20palette%2C%20wellness%20and%20natural%20healing%20concept%2C%20clean%20lifestyle%20photography&width=800&height=450&seq=art-19-thumb&orientation=landscape",
  },
  {
    id: "art-20",
    slug: "yundong-jianshen-chuxuezhe",
    title: "运动健身初学者指南：从零开始的科学训练计划",
    excerpt: "想要开始健身却不知从何下手？本文为健身新手量身定制了科学的入门训练计划，涵盖力量训练、有氧运动和拉伸放松。",
    content: `<p>开始运动健身是改善健康状况的最佳决定之一，但对于新手来说，健身房里的各种器械和网上的海量信息常常让人望而却步。其实，健身入门并不复杂，关键是循序渐进、坚持执行。</p>
<p>对于零基础的健身新手，建议从每周3次训练开始，每次45-60分钟。训练内容应该包含热身（5-10分钟）、主体训练（30-40分钟）和拉伸放松（5-10分钟）三个部分。最重要的是学会正确的动作姿势，这比重量大小重要得多。</p>
<p>主体训练可以分为力量训练和有氧训练两个部分。力量训练建议从复合动作开始，如深蹲、俯卧撑、划船和肩推等，这些动作能同时锻炼多个肌群，效率最高。初期使用自重或很轻的重量，每组做10-15次，2-3组即可。</p>
<p>有氧训练可以选择快走、慢跑、骑自行车或椭圆机，持续20-30分钟，保持能说话但不能唱歌的强度水平。随着体能的提升，可以逐渐增加训练的强度和时间。</p>`,
    categorySlug: "jiankang-yangsheng",
    author: "健身教练Aaron",
    publishDate: "2025-07-15",
    readTime: "9分钟",
    thumbnailUrl: "https://readdy.ai/api/search-image?query=Bright%20modern%20gym%20space%20with%20clean%20equipment%20and%20natural%20lighting%2C%20inviting%20fitness%20environment%2C%20minimal%20workout%20area%2C%20warm%20atmosphere&width=800&height=450&seq=art-20-thumb&orientation=landscape",
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.slice(0, 8);
};

export const getLatestArticles = (): Article[] => {
  return [...articles].sort((a, b) =>
    new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );
};

export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, count);
};